import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import Input from "@material-ui/core/Input/index";
import Button2 from "@material-ui/core/Button/index";
import { FaRegWindowClose } from "react-icons/fa";
import SVG from "react-inlinesvg";
import { FaUpload } from "react-icons/fa";
import CircularProgress from "@material-ui/core/CircularProgress/index";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers/index.js";
import imageCompression from "browser-image-compression";
import Preview from "../components/Preview.js";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";

const initialValues = {
  file: "",
};
export default function Employers(props) {
  const token = useSelector((state) => state.auth.token);
  const { chooseId, show, onHide, face, onFaceChoose } = props;
  const { image } = face;
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const [cameraImage, setCameraIamge] = useState(null);
  const [localImage, setLocalIamge] = useState(null);

  const fileUrl = image;

  const [isError, setIsError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [imageSrc, setImageSrc] = useState(fileUrl);
  const [preview, setPreview] = useState(true);
  const [file, setFile] = useState("");
  const form = useRef(null);
  const CreateSchema = Yup.object().shape({
    // file: Yup.mixed().test(
    //   "fileSize",
    //   "Yüklədiyiniz şəkil ölçüsü 200 KB-dan çox olmamalıdır ",
    //   (value) => {
    //     if (!value) return true;
    //     const maxFileSizeKB = 200;
    //     return value.size / 1024 <= maxFileSizeKB;
    //   }
    // ),
  });
  useEffect(() => {
    setImageSrc(fileUrl);
  }, [fileUrl]);

  const getInputClasses = (filedName) => {
    if (formik.touched[filedName] && formik.errors[filedName]) {
      return true;
    }
    if (formik.touched[filedName] && !formik.errors[filedName]) {
      return false;
    }

    return false;
  };

  const imagePreview = async (e) => {
    try {
      if (e.target && e.target.files && e.target.files.length > 0) {
        let reader = new FileReader();
        let file = e.target.files[0];

        // Compress the image using browser-image-compression library
        const options = {
          maxSizeMB: 0.18,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
        };

        // Asenkron sıkıştırma işlemini beklemek için await kullan
        const compressedFile = await imageCompression(file, options);

        // Set the compressed file to the local state or use it as needed
        setLocalIamge(compressedFile);

        // Set the formik field value
        formik.setFieldValue("file", compressedFile);

        // Read the compressed file as a data URL for preview
        reader.onloadend = () => {
          setImageSrc(reader.result);
        };

        reader.readAsDataURL(compressedFile);
        setPreview(true);
      } else {
        console.error("No file selected.");
      }
    } catch (error) {
      console.error("Error compressing image:", error);
    }
  };

  const onClick = (e) => {
    setPreview(false);
    setImageSrc("");
    formik.setFieldValue("file", "");
    setFile("");
  };

  const onPostGroup = (values, resetForm, setSubmitting) => {
    if (!isCameraOpen) {
      setIsLoading(true);
      const formDatas = new FormData();
      formDatas.append("pin", chooseId);
      if (localImage) {
        formDatas.append("file", localImage, "captured-image.png");
      } else if (cameraImage) {
        formDatas.append("file", cameraImage, "captured-image.png");
      } else {
        formDatas.append("file", null);
      }
      axios
        .put(
          `${process.env.REACT_APP_API_URL}hikvision/face/${chooseId}`,
          formDatas,
          {
            headers: {
              Authorization: `bearer ${token}`,
            },
          }
        )
        .then((res) => {
          setSubmitting(false);
          resetForm();
          onHide(false);
          setPreview(false);
          setImageSrc("");
          setFile("");
          setIsLoading(false);
          onFaceChoose(chooseId);
        })
        .catch((err) => {
          let message =
            typeof err.response !== "undefined"
              ? err.response.data.message
              : err.message;
          setIsError(message);
          setIsLoading(false);
        });
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema: CreateSchema,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      onPostGroup(values, resetForm, setSubmitting);
    },
  });

  const resetForm = () => {
    onHide();
    formik.resetForm();
    handleCloseClick();
  };

  useEffect(() => {
    setIsError("");
  }, [show]);

  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const handleCloseClick = (e) => {
    if (e) {
      e.preventDefault();
    }
    if (videoRef.current) {
      const video = videoRef.current;
      const tracks = video.srcObject?.getTracks() || [];
      tracks.forEach((track) => track.stop());
      video.srcObject = null;
      video.src = "";
      setIsCameraOpen(false);
      // setImageSrc(""); // Clear the existing image
    }
  };
  const handleButtonClick = async (e) => {
    e.preventDefault();
    formik.setFieldValue("file", "");

    // Check if mediaDevices API is available
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      console.error("Error: getUserMedia is not supported in this browser.");
      return;
    }

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });

      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        setIsCameraOpen(true);
        setImageSrc("");
      }
    } catch (error) {
      console.error("Error accessing camera:", error);
    }
  };

  const [cameraLoading, setCameraLoading] = useState(false);
  const handleCaptureClick = async (e) => {
    e.preventDefault();
    setCameraLoading(true);
    if (videoRef.current && canvasRef.current) {
      const video = videoRef.current;
      const canvas = canvasRef.current;
      const context = canvas.getContext("2d");

      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      context.drawImage(video, 0, 0, canvas.width, canvas.height);

      try {
        const blob = await new Promise((resolve, reject) => {
          canvas.toBlob((blob) => {
            if (blob) {
              resolve(blob);
            } else {
              reject(new Error("Failed to create blob from canvas."));
            }
          }, "image/png");
        });

        if (blob) {
          const options = {
            maxSizeMB: 0.18,
            maxWidthOrHeight: 1920,
            useWebWorker: true,
          };

          try {
            const compressedBlob = await imageCompression(blob, options);

            // Continue with the rest of your code using the compressedBlob
            const capturedImageSrc = URL.createObjectURL(compressedBlob);
            setImageSrc(capturedImageSrc);
            setPreview(true);
            setFile("");
            setIsCameraOpen(false);
            setCameraIamge(compressedBlob);

            // Reset canvas
            canvas.width = 0;
            canvas.height = 0;

            // Stop video tracks
            const tracks = video.srcObject.getTracks();
            tracks.forEach((track) => track.stop());

            // Reset video element
            video.srcObject = null;
            video.src = "";
          } catch (error) {
            console.error("Error compressing image:", error);
          }
        }
      } catch (error) {
        console.error("Error creating blob from canvas:", error);
      } finally {
        // İşlem tamamlandığında loading durumunu false olarak ayarla
        setCameraLoading(false);
      }
    }
  };
  return (
    <Modal
      show={show}
      onHide={resetForm}
      size="xl"
      aria-labelledby="edit"
      centered
      className="pr-0"
    >
      <form onSubmit={formik.handleSubmit} ref={form}>
        <Modal.Header closeButton>
          <Modal.Title id="delete">
            İnsan resurslarının üz təsvirinin düzəlişi
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row bg-white rounded">
            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3">
                <label htmlFor="contained-button-file">
                  <input
                    accept=".png"
                    id="contained-button-file"
                    type="file"
                    name="file"
                    label="File {Path}"
                    placeholder="File Path"
                    className="w-100"
                    onChange={imagePreview}
                    value={file}
                    hidden
                  />
                  {!isCameraOpen && (
                    <Button2 variant="contained" component="span">
                      <div className="upload_icons">
                        <FaUpload />
                      </div>
                      Şəkİl yüklə
                    </Button2>
                  )}
                  {!isCameraOpen && (
                    <Button2
                      variant="contained"
                      onClick={handleButtonClick}
                      className="ml-3"
                    >
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Devices/Camera.svg"
                        )}
                        className="mr-2"
                      />
                      Kameranı aç
                    </Button2>
                  )}
                  {isCameraOpen && (
                    <Button2
                      variant="contained"
                      onClick={handleCloseClick}
                      className="ml-3"
                    >
                      <div className="upload_icons">
                        <FaRegWindowClose />
                      </div>
                      Kameranı bağla
                    </Button2>
                  )}

                  {isCameraOpen && (
                    <Button2
                      variant="contained"
                      onClick={handleCaptureClick}
                      className="ml-3 camera_capture"
                    >
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Devices/Camera.svg"
                        )}
                        className="mr-2"
                      />
                      Şəkİl çək
                    </Button2>
                  )}
                </label>
                {imageSrc && !isCameraOpen && !cameraLoading && (
                  <Preview
                    preview={preview}
                    imageSrc={imageSrc}
                    onClick={onClick}
                  />
                )}
                {cameraLoading && (
                  <div className="d-flex w-100 justify-content-center align-items-center">
                    <div>
                      <CircularProgress />
                    </div>
                    <h3>Şəkil hazırlanır...</h3>
                  </div>
                )}
              </div>
              {formik.touched.file && formik.errors.file ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block" style={{ fontSize: "18px" }}>
                    {formik.errors.file}
                  </div>
                </div>
              ) : null}
            </div>
            <div className="image-preview w-100">
              <video ref={videoRef} autoPlay playsInline />
              <canvas ref={canvasRef} style={{ display: "none" }} />
            </div>
          </div>

          {/* <button onClick={() => handleDownloadLogo()}>Salam</button> */}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="light"
            onClick={(e) => {
              onHide(false);
              formik.resetForm();
              handleCloseClick(e);
            }}
          >
            Ləğv et
          </Button>
          <Button type="submit" className={isLoading ? "px-9" : ""}>
            <span>Düzəliş et</span>
            {isLoading && <span className="ml-3 spinner spinner-white"></span>}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
